import RegionAPI from "@/api/RegionAPI";
// import {idUserForApi} from "@/controllers/UserController";

class RegionController {
  constructor() {
    this.api = RegionAPI;
  }

  _checkId(id) {
    if (!id)
      throw new Error('id cannot be null');
  }

  // /**
  //  * @param {Number} uslId
  //  * @param {1 | 2 | 3} foId
  //  * @param { Number | null | undefined } [regionId]
  //  * */
  async getRegionsWithScanFilesData() {
    try {
      // regionId = regionId ?? idUserForApi(regionId);
      // this._checkId(regionId);
      const res = await this.api.getRegionsWithScanFiles();
      return res.data
    } catch (e) {
      console.error('error getDataStage ' + e.message)
      throw new Error('error getDataStage ' + e.message)
    }
  }
}

export default new RegionController();